// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"c13fb9b2","316":"a2b01fcd","444":"5cadae1f","522":"d6bc26ce","615":"05b30af3","886":"3f7ba28b","931":"a9a65adf","933":"282dc2c5","969":"20ce4f10"}[chunkId] + ".css";
};